// catalog.ts — Four-domain catalog read surface.
// See workers/core-os/src/routes/catalog.ts (v_work_item_rollup, migration 0096).
// One row per work item with a column per domain (SOW / schedule / inspection /
// spec) + FMEA QA weighting. Backs the Catalog Workbench (/admin/catalog).

import { request } from './request'

export interface WorkItemRollupRow {
  work_item_id: string
  fp_id: string
  phase_num: number
  phase: string
  seq: number
  work_item: string
  class: string
  cross_cutting: number
  // SOW domain
  sow_native_trade: string | null
  sow_trades: string | null
  // Schedule domain
  schedule_predecessors: string | null
  // Inspection domain
  inspection_native_gate: string | null
  inspection_gate_links: string | null
  // Spec domain
  spec_links: string | null
  // QA weighting
  fmea_rpn: number | null
  catalog_version: string
}

export interface WorkItemRollupResponse {
  ok: true
  count: number
  work_items: WorkItemRollupRow[]
}

export interface CatalogPhase {
  phase_num: number
  phase: string
  item_count: number
}

export interface CatalogPhasesResponse {
  ok: true
  phases: CatalogPhase[]
}

export const catalogApi = {
  workItems: (params?: { phase?: number; q?: string; limit?: number }) => {
    const qs = new URLSearchParams()
    if (params?.phase != null) qs.set('phase', String(params.phase))
    if (params?.q != null && params.q !== '') qs.set('q', params.q)
    if (params?.limit != null) qs.set('limit', String(params.limit))
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return request<WorkItemRollupResponse>(`/api/catalog/work-items${suffix}`)
  },
  phases: () => request<CatalogPhasesResponse>('/api/catalog/phases'),
}
